import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import {
  captureInstallPrompt,
  enforceHttps,
  injectCspMeta,
  initSentry,
} from "@dwelldrop/shared";
import "@uiw/react-md-editor/markdown-editor.css";
import "@uiw/react-markdown-preview/markdown.css";
import App from "./App";

// ─── Monitoring bootstrap ───────────────────────────────────────────────────
initSentry({
  appName: "admin",
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  isProd: import.meta.env.PROD,
});

// ─── Security bootstrap ─────────────────────────────────────────────────────
enforceHttps();

captureInstallPrompt();

injectCspMeta({
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL,
});

if (import.meta.env.DEV) {
  import("react-grab");
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
